import { render, staticRenderFns } from "./p-addinfo.vue?vue&type=template&id=105c1b29&scoped=true"
import script from "./p-addinfo.vue?vue&type=script&lang=js"
export * from "./p-addinfo.vue?vue&type=script&lang=js"
import style0 from "./p-addinfo.vue?vue&type=style&index=0&id=105c1b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c1b29",
  null
  
)

export default component.exports